__turbopack_context__.v({
  "className": "mona_sans_ed2904a8-module__hxO9Va__className",
});
